import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { controlTypes } from '@zipari/shared-ds-util-form';
import { FormattingService } from '../../shared/services/formatting.service';

@Injectable({
  providedIn: 'root',
})
export class ListViewHelper {
  constructor(private formattingService: FormattingService) {}

  createDateString(
    dateRangeConfig: Record<string, string>,
    dateRangeValue: Record<string, string>,
  ) {
    const { label } = dateRangeConfig;
    let { startProp, endProp } = dateRangeConfig;
    let dateFiltersString = '';

    // If there is no custom start or end prop names, use defaults
    startProp = startProp || 'start';
    endProp = endProp || 'end';
    if (dateRangeValue) {
      const startVal = this.formattingService.restructureValueBasedOnFormat(
        dateRangeValue[startProp],
        {
          format: 'DATE',
        },
      );
      const endVal = this.formattingService.restructureValueBasedOnFormat(
        dateRangeValue[endProp],
        { format: 'DATE' },
      );

      if (startVal && endVal) {
        dateFiltersString += `${label} ${startVal} - ${endVal}`;
      } else if (startVal && !endVal) {
        dateFiltersString += `${label} after ${startVal}`;
      } else if (!startVal && endVal) {
        dateFiltersString += `${label} before ${endVal}`;
      }
    }

    return dateFiltersString;
  }

  buildFiltersString(filtersConfig, filtersForm: UntypedFormGroup) {
    const filtersArray = [];
    let filtersString = '';

    // loop through the keys of the filter form
    Object.keys(filtersForm.value).forEach((key: string) => {
      // find the form control with a `prop` that matches the key
      const control = filtersConfig.controls.find((ctrl) => ctrl.prop === key);
      const value = filtersForm.value[key];
      // Ignore undefined controls as well as falsy values

      if (!!control && value) {
        switch (control?.type) {
          // for form controls with `options`, find the selected option and use its value
          case controlTypes.checkbox:
          case controlTypes.dropdown:
          case controlTypes.radio:
          case controlTypes.toggle:
            const selectedOption = control.options.find((option) =>
              !value ? option.value === null : option.value === value,
            );

            filtersArray.push(`${selectedOption?.label}`);
            break;
          // for `dateRange` controls, display either the range between selected dates, or before/after single selected date
          case controlTypes.dateRange:
            filtersArray.push(this.createDateString(control, value));
            break;
          // everything else, display the label and the value
          default:
            if (value) {
              filtersArray.push(`${control.label} ${value}`);
            }
            break;
        }
      }
    });

    filtersString = filtersArray.filter((str) => str.length > 0).join(', ');

    // Return a blank string if the filters are all null. If not, trim trailing comma and whitespace
    return filtersString.length > 0
      ? `Viewing ${filtersString.replace(/,\s*$/, '')}`
      : '';
  }
}
